// token令牌
export const ACCOUNT_TOKEN = 'ACCOUNT_TOKEN';
// 广场Id
export const ACCOUNT_PLAZA_ID = 'ACCOUNT_PLAZA_ID';
// 广场名称
export const ACCOUNT_PLAZA_NAME = 'ACCOUNT_PLAZA_NAME';
// 用户Id
export const ACCOUNT_USER_ID = 'ACCOUNT_USER_ID';
// 租户Id
export const ACCOUNT_TENANT_ID = 'ACCOUNT_TENANT_ID';
// 店铺Id
export const ACCOUNT_STORE_ID = 'ACCOUNT_STORE_ID';
// 用户手机号
export const ACCOUNT_MOBILE = 'ACCOUNT_MOBILE';
// 店铺名称
export const BASE_STORE_NAME = 'BASE_STORE_NAME';
// 角色类型
export const ACCOUNT_ROLE_TYPE = 'roleType';
// 用户姓名
export const ACCOUNT_NAME = 'ACCOUNT_NAME';
// 进入场景
export const BASE_ENTER_SCENE = 'BASE_SCENE';
// 页面可见区域高
export const BASE_STAGE_HEIGHT = 'BASE_STAGE_HEIGHT';
